<div class="scheduler-wrapper-workers-planner flex flex-row" style="height: 100vh; overflow: hidden;">
  <div class="scheduler" style="position: relative; width: 100%; height: 100vh;">
    <div [ngStyle]="{'margin-top': drawerOpened ? '12px' : '4px'}" class="flex flex-row gap-1" style="position: absolute;top: 4px;right: 240px;z-index: 10;display: flex;align-items: center;gap: 12px;">
      <div class="relative">
        <dx-tag-box
          [label]="'common.selectAdvancedFilter' | translate"
          (click)="toggleDrawer()"
          *ngIf="!drawerOpened"
          [width]="'700px'"
          [value]="activeFilters"
          [scrollable]="true"
          [multiline]="false">

          <div  class="tag dx-tag-content" *dxTemplate="let item of 'tag'">
            {{ item }}
          </div>
        </dx-tag-box>
        <div *ngIf="!drawerOpened" (click)="toggleDrawer()" style="height: 40px; width: 400px; position: absolute; top:0px; cursor: pointer;" >
        </div>
      </div>

      <dx-button-group
        buttonTemplate="myTemplate"
        [items]="utilitiesButtons"
        keyExpr="cellDuration"
        stylingMode="contained"
        (onItemClick)="refresh()"
        style="margin-left: 20px;"
      >
        <div style="width: 63px;" *dxTemplate="let buttonData of 'myTemplate'">
          <span class="theme-color-text font-bold" [icon]="buttonData.icon"></span>
        </div>
      </dx-button-group>
      <dx-button-group
        #buttonGroup1
        *ngIf="scheduler?.currentView !== 'month'"
        buttonTemplate="myTemplate"
        [items]="cellDurations"
        keyExpr="cellDuration"
        stylingMode="contained"
        [selectedItemKeys]="[selectedCellDuration]"
        (onItemClick)="changeCellDuration($event)"
        style="margin-left: 20px; margin-right: 20px;"
      >
        <div style="width: 63px;" *dxTemplate="let buttonData of 'myTemplate'">
          <span class="theme-color-text font-bold">{{buttonData.cellDuration}} m</span>
        </div>
      </dx-button-group>

      <dx-button-group
        *ngIf="scheduler?.currentView !== 'month'"
        buttonTemplate="myTemplate"
        [items]="cellDurationsZoom"
        keyExpr="cellDuration"
        stylingMode="contained"
        [selectedItemKeys]="['15']"
        (onItemClick)="changeCellDurationZoom($event)"
      >
        <div style="width: 63px;" *dxTemplate="let buttonData of 'myTemplate'">
          <span class="theme-color-text font-bold" [icon]="buttonData.icon"></span>
        </div>
      </dx-button-group>
    </div>
    <dx-load-panel
      #loadPanel
      shadingColor="rgba(0,0,0,0.4)"
      [position]="{ of: '#scheduler' }"
      [(visible)]="loadingVisible"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [hideOnOutsideClick]="false"
    >
    </dx-load-panel>
    <dx-tooltip
      #tooltip
      target="#scheduler"
      position="top"
      [(visible)]="tooltipVisible"
    >
      <div *dxTemplate>
        <div class="tooltip-content">
        </div>
      </div>
    </dx-tooltip>
    <dx-scheduler
      #scheduler
      startDateExpr="startTime"
      endDateExpr="endTime"
      [timeZone]="timezone"
      [dataSource]="operations"
      [views]="views"
      currentView="week"
      [currentDate]="currentDate"
      [cellDuration]="15"
      height="95vh"
      style ="position: relative;"
      appointmentTemplate="appointment-template"
      appointmentTooltipTemplate="tooltip-template"
      (onOptionChanged)="onOptionChanged($event)"
      (onAppointmentClick)="onAppointmentClick($event)"
      (onAppointmentDblClick)="onAppointmentDbClick($event)"
      (onAppointmentFormOpening)="onAppointmentFormOpening($event)"
      (onAppointmentUpdated)="onAppointmentUpdated($event)"
      (onAppointmentRendered)="onAppointmentRendered($event)"
      [useDropDownViewSwitcher]="false"
    >
      <div *dxTemplate="let model of 'appointment-template'">
        <div [ngStyle]="{
          'background-color': model.appointmentData.productionOrderId === selectedProductionOrderId ? 'rgba(40, 160, 115, 0.13)' : 'white',
          'height': '-webkit-fill-available',
          'width': '-webkit-fill-available'
        }" class="ticket theme-color-text p-2">
          <div (mouseleave)="onMouseLeave()" (mouseenter)="onMouseEnter($event, model)"  class="mt-1 flex flex-col gap-2">
            <div class="flex flex-row justify-between items-center">
              <div>
                <div class="flex flex-row mx-1 gap-1">
                  <div [title]="worker.name" class="relative mt-1" *ngFor="let worker of model.appointmentData.workersList">
                    <img id="image4" class="rounded-full" style="height: 24px;"  *ngIf="worker.avatar" [src]="worker.avatar" alt="Avatar">
                    <div
                      id="image3"
                      *ngIf="!worker.avatar"
                      class="text-white dx-theme-accent-as-background-color"
                      style="display:flex; align-items:center; justify-content:center; width:24px; height:24px; box-sizing:border-box; border-radius:50%; font-size:10px; line-height:1; padding:0; text-align:center;"
                    >
                      {{ getLogo(worker.name) }}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <ng-container *ngIf="model.appointmentData.stateId">
                <span class="px-2 py-1 text-xs text-white rounded-full ml-1"
                      [style.background-color]="stateColors[model.appointmentData.stateId]">
                  {{ operationStates[model.appointmentData.stateId] | ucfirst  }}
                </span>
                </ng-container>
              </div>
            </div>
            <div class="flex justify-between items-baseline">
              <div class="flex items-center justify-between mb-2">
                <div class="flex items-center gap-2">
                  <span class="mt-0.5" icon="format_list_bulleted"  [iconSize]="'18px'" ></span>
                  <span class="font-semibold text-base">{{ model.appointmentData?.document }}</span>
                </div>
              </div>
              <dx-drop-down-button displayExpr="text" (onItemClick)="onActionClick($event, model.appointmentData)" icon="more_vert" [showArrowIcon]="false" class="theme-color-text" stylingMode="text">
                <dxi-item
                  [id]="ActionType.Split"
                  [icon]="'splitscreen_add'"
                  [text]="'planner.split' | translate | ucfirst"
                ></dxi-item>
                <dxi-item
                  [disabled]="model.appointmentData.timeSlots.length === 1"
                  [id]="ActionType.Delete"
                  [icon]="'splitscreen_bottom'"
                  [text]="'planner.delete' | translate | ucfirst"
                ></dxi-item>
                <dxi-item
                  [id]="ActionType.Reschedule"
                  [icon]="'splitscreen'"
                  [text]="'planner.reschedule' | translate | ucfirst"
                ></dxi-item>

                <dxo-drop-down-options width="320px"/>
              </dx-drop-down-button>
            </div>

            <ng-container
              *ngTemplateOutlet="operationInfoTemplate; context: { data: model.appointmentData }">
            </ng-container>

          </div>
        </div>
      </div>
      <div *dxTemplate="let model of 'tooltip-template'">
        <div class="p-2">
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center gap-2">
              <span class="mt-0.5" icon="format_list_bulleted"  [iconSize]="'18px'" ></span>
              <span class="font-semibold text-base">{{ model.appointmentData?.document }}</span>
            </div>

            <ng-container *ngIf="model.appointmentData.stateId">
                <span class="px-2 py-1 text-xs text-white rounded-full"
                      [style.background-color]="stateColors[model.appointmentData.stateId]">
                  {{ operationStates[model.appointmentData.stateId] | ucfirst  }}
                </span>
            </ng-container>
          </div>
          <ng-container
            *ngTemplateOutlet="operationInfoTemplate; context: { data: model.appointmentData }">
          </ng-container>
        </div>

      </div>

    </dx-scheduler>
  </div>
  <div class="filters p-2" [ngStyle]="{'width': drawerOpened ? '400px' : '0px', 'overflow': 'hidden', 'padding': drawerOpened ? '8px' : '0', 'margin': drawerOpened ? '8px' : '0'}">
    <div style="height: 92vh;"  class="flex flex-col justify-between" >
      <div class="flex flex-col gap-2">
        <div class="flex flex-row gap-1 justify-between align-items-center m-3">
          <div style="font-size: 1.25rem; font-weight: bold;">{{'common.operationFilter' | translate |ucfirst}}</div>
          <dx-button (click)="toggleDrawer()" icon="close"></dx-button>
        </div>
        <dx-tag-box *ngIf="plants"
                    [dataSource]="plants"[placeholder]="'menu.breadcrumb.plants' | translate"
                    valueExpr="id"
                    displayExpr="name"
                    [(value)]="tagBoxValuePlants"
        />
        <dx-tag-box *ngIf="workers"
                    [dataSource]="workers"[placeholder]="'menu.breadcrumb.workers' | translate"
                    valueExpr="id"
                    displayExpr="name"
                    [(value)]="tagBoxValueWorker"
        />
        <dx-tag-box *ngIf="organitzationsDataSource"
                    [dataSource]="organitzationsDataSource"[placeholder]="'menu.breadcrumb.organitzations' | translate | ucfirst"
                    valueExpr="id"
                    displayExpr="legalName"
                    [(value)]="tagBoxValueOrganizations"
        />
        <dx-tag-box *ngIf="documentTypes"
                    [dataSource]="documentTypes" [placeholder]="'menu.preferences.adminMenu.documentTypes' | translate"
                    valueExpr="id"
                    displayExpr="name"
                    (valueChange)="onDropDownBoxValueChanged($event)"
                    [(value)]="tagBoxxValueDocumentTypes"
        />
        <dx-tag-box *ngIf="statuses && statuses.length > 0"
                    [dataSource]="statuses" [placeholder]="'entity.documentType.tabs.states' | translate"
                    valueExpr="id"
                    displayExpr="name"
                    #statusesTagBox
                    [(value)]="tagBoxValueDocumentTypeStates"
        />
      </div>
      <div class="mt-3 text-right">
        <dx-button
          (onClick)="aplyFilters()"
          [type]="'default'"
          [icon]="'done'"
          [text]="'common.save' | translate | ucfirst"
        ></dx-button>
      </div>
    </div>
  </div>
  <dx-popup
    [visible]="editComponentVisible"
    [title]="selectedOperation?.productionOrderNumber + ' | ' + selectedOperation?.productionOrderDocumentTypeName"
    [showTitle]="true" [showCloseButton]="true"
    height="auto" minHeight="520px" width="450px"
    (onHidden)="editComponentVisible = false">
    <app-edit-workers-planner
      *ngIf="editComponentVisible"
      [operation]="selectedOperation"
      [planner]="planner"
      [workersOfSelectedOperation]="workersOfSelectedOperation"
      (saveChanges)="saveChanges($event)"
      (navigate)="navigateToProductionOrder($event)"
      (move)="move($event)"></app-edit-workers-planner>
  </dx-popup>
  <dx-popup
    [visible]="rescheduleOperation"
    [title]="this.selectedOperation?.productionOrderNumber + ' | ' + this.selectedOperation?.operationTypeName "
    [showTitle]="true" [showCloseButton]="true"
    height="auto" minHeight="320px" width="420px"
    (onHidden)="rescheduleOperation = false">
    <div>
      @if(operationDatesForm && operationDatesForm.get('duration')){
        <form [formGroup]="operationDatesForm" >
          <gs-time-span-field
            [label]="'common.duration' | translate"
            formField required formControlName="duration"
            [dates]="{
                        startDate: selectedOperation!.startTime,
                        endDate: selectedOperation!.endTime
                      }"
          />
          <dx-date-box type="datetime" formField required formControlName="startTime" [label]="'entity.appointment.startActivationDateTime' | translate"/>
          <div class="flex justify-end" >
            <dx-button
              (onClick)="saveRescheduleOperation()"
              [disabled]="!operationDatesForm.valid"
              [type]="'default'"
              [icon]="'done'"
              [text]="'common.save' | translate | ucfirst"
            ></dx-button>
          </div>
        </form>
      }
    </div>
  </dx-popup>
</div>
<ng-template #operationInfoTemplate let-data="data">
  <div style="white-space: normal" class="text-sm mb-2 ml-7 text-start">
    {{ joinWithSeparator([data?.operationTypeName, data?.name, data?.description], " | ") }}
  </div>

  @if (formatProjectAndOrganizationsStrings( data && data.projects)) {
    <div class="flex items-start gap-2 mt-1 text-sm">
      <span [iconSize]="'18px'" class="mt-0.5" icon="account_balance"></span>
      <div class="flex flex-col text-start">
        <span style="white-space: normal">
          {{ formatProjectAndOrganizationsStrings(data.projects) }}
        </span>
      </div>
    </div>
  }

  @if (formatProjectAndOrganizationsStrings( data && data.organizations)) {
    <div class="flex items-start gap-2 mt-1 text-sm">
      <span [iconSize]="'18px'" class="mt-0.5" icon="corporate_fare"></span>
      <div class="flex flex-col text-start">
        <span style="white-space: normal">
          {{ formatProjectAndOrganizationsStrings(data.organizations) }}
        </span>
      </div>
    </div>
  }


  @if(data?.productionOrderAssetCode){
    <div class="flex items-start gap-2 mt-1 text-sm">
      <span
        [iconSize]="'18px'"
        class="mt-0.5"
        [icon]="data.productionOrderOssetNodeType === 1 ? 'location' : 'precision_manufacturing'">
      </span>
      <div class="flex flex-col text-start">
        <span style="white-space: normal">
          {{ joinWithSeparator([data?.productionOrderAssetCode, data?.productionOrderAssetName], " | ") }}
        </span>
      </div>
    </div>
  }

  <div class="flex items-start gap-2 mt-1 text-sm">
    <span [iconSize]="'18px'" class="mt-0.5" icon="factory"></span>
    <div class="flex flex-col text-start">
      <span style="white-space: normal">
        {{ joinWithSeparator([data?.document, data?.productionOrderDocumentTypeName, data.productionOrderSubject], " | ") }}
      </span>
    </div>
  </div>

  <div class="flex flex-col gap-1 mt-1 text-sm">
    <div class="flex items-center gap-2 justify-start">
      <div class="flex items-center gap-2">
        <span class="mt-0.5" icon="schedule" [iconSize]="'18px'"></span>
        <span class="font-medium">{{ 'common.planned' | translate }}:</span>
      </div>
      <span>{{ data?.operationDuration }}</span>
    </div>

    @if (data?.executedTime) {
      <div class="flex items-center gap-2 justify-start">
        <div class="flex items-center gap-2">
          <span class="font-medium ml-7">{{ 'common.pending' | translate }}:</span>
        </div>
        <span>{{ data?.executedTime }}</span>
      </div>
    }

    @if (data?.pendingTime) {
      <div class="flex items-center gap-2 justify-start">
        <div class="flex items-center gap-2">
          <span class="font-medium ml-7">{{ 'common.executed' | translate }}:</span>
        </div>
        <span>{{ data?.pendingTime }}</span>
      </div>
    }
  </div>

  <hr class="my-2 opacity-30" />
</ng-template>
